export const getRequestHeaders = (token: string, withBody: boolean = false) => {
    const headers: Headers = new Headers()
    headers.set('Authorization', `Bearer ${token}`)

    if(withBody) {
        headers.set('Content-Type', 'application/json')
    }

    return headers
}
